const grecaptcha = window.grecaptcha;

jQuery(function ($) {
  var recaptchaPublicKey = $('meta[name=recaptcha_public]').attr('content');

  var $askDeviceForm = $('#ask_device_form');
  var $sendDeviceForm = $('#send_device_form');

  console.log('JS _device_forms.js chargé et exécuté');

  // Ask Device Form
  if ($askDeviceForm.length > 0) {
    console.log('ask_device_form trouvé');
    checkAskDeviceForm($askDeviceForm);

    $askDeviceForm.find('*').on('change', function () {
      console.log('Changement détecté dans ask_device_form');
      checkAskDeviceForm($askDeviceForm);
    });

    $.validator.addMethod(
      'requireOneCheckedHowDidYouHear',
      function () {
        const checked = $('input[name=\'how_did_you_hear[]\']:checked').length;
        console.log('Validation requireOneCheckedHowDidYouHear, checked:', checked);
        return checked > 0;
      },
      'Veuillez cocher au moins une option pour \'Comment nous avez-vous connu ?\'.'
    );

    var askDeviceFormValidator = $askDeviceForm.validate({
      debug: true,
      showErrors: function () {
        console.log('showErrors appelé');
        this.defaultShowErrors();
      },
      errorPlacement: function (label, element) {
        console.log('errorPlacement appelé pour', element.attr('name'), element.attr('type'));
        // Gestion spécifique pour le groupe de cases à cocher "how_did_you_hear[]"
        if (element.attr('name') === 'how_did_you_hear[]' || (element.attr('type') === 'checkbox' && element.attr('name') === 'how_did_you_hear[]')) {
          // Toujours afficher UNE SEULE bulle d'erreur sous le groupe, jamais sur chaque case
          if ($('#how_did_you_hear_error_placeholder label.error').length === 0) {
            label.addClass('error');
            $('#how_did_you_hear_error_placeholder')
              .empty()
              .append(label)
              .removeClass('error');
            console.log('Erreur placée dans #how_did_you_hear_error_placeholder');
          }
        } else if (element.attr('type') == 'checkbox') {
          element.parent().append(label);
        } else if (element.attr('type') == 'radio') {
          element.parents('.form-group').append(label);
        } else if (element.attr('type') == 'file') {
          element.parents('.form-group').append(label);
        } else {
          label.insertAfter(element);
        }
      },
      messages: {
        //
      },
      rules: {
        dest_suivi_other: {
          required: '#dest_suivi_other:checked',
        },
        photo_0: {
          required: true,
          extension: 'gif|png|jpg|jpeg|pdf',
          enable_maxsize: 2,
        },
        photo_1: {
          required: true,
          extension: 'gif|png|jpg|jpeg|pdf',
          enable_maxsize: 2,
        },
        photo_2: {
          required: true,
          extension: 'gif|png|jpg|jpeg|pdf',
          enable_maxsize: 2,
        },
        'how_did_you_hear[]': {
          requireOneCheckedHowDidYouHear: true,
        },
      },
    });

    $askDeviceForm.on('submit', function (e) {
      e.preventDefault();
      console.log('Soumission du ask_device_form');
      var $myForm = $(this);
      var target = $myForm.attr('action');
      // var formData = $myForm.serializeArray();
      var formData = new FormData(this);
      var $submitButton = $myForm.find('button[type=submit]');
      var submitButtonHtml = $submitButton.html();

      $myForm.find('.alert').fadeOut();

      if (!askDeviceFormValidator.valid()) {
        console.log('askDeviceFormValidator.valid() == false');
        // Check if form is valid
        return false;
      }
      console.log('askDeviceFormValidator.valid() == true, envoi du formulaire');
      $submitButton
        .attr('disabled', 'disabled')
        .html('<i class=\'fas fa-circle-notch fa-spin\'></i>');

      formData.append('action', 'ajaxaskdevice');

      grecaptcha
        .execute(recaptchaPublicKey, { action: 'contact' })
        .then(function (token) {
          formData.append('recaptchaToken', token);

          $.ajax({
            type: 'POST',
            data: formData,
            url: target,
            processData: false,
            contentType: false,
          })
            .always(function () {
              $submitButton.removeAttr('disabled').html(submitButtonHtml);
            })
            .done(function () {
              var $alert = $myForm.parent().find('.alert-success');
              $myForm.fadeOut(function () {
                $alert.fadeIn();
                $('html, body').animate({
                  scrollTop: $alert.offset().top - 30,
                });
              });
            })
            .fail(function (response) {
              var $alert = $myForm.find(
                '.alert.alert-danger[data-error-id=' +
                  response.responseJSON.data.error_id +
                  ']'
              );

              if ($alert.length <= 0) {
                $alert = $myForm.find(
                  '.alert.alert-danger[data-error-id=none]'
                );
              }

              if ($alert.length > 0) {
                $alert.fadeIn();
                $('html, body').animate({
                  scrollTop: $alert.offset().top - 30,
                });
              }
            });
        });
    });
  }

  // Send Device Form
  if ($sendDeviceForm.length > 0) {
    var sendDeviceFormValidator = $sendDeviceForm.validate({
      debug: true,
      showErrors: function () {
        this.defaultShowErrors();
      },
      errorPlacement: function (label, element) {
        if (element.attr('type') == 'checkbox') {
          element.parent().append(label);
        } else if (element.attr('type') == 'radio') {
          element.parents('.form-group').append(label);
        } else if (element.attr('type') == 'file') {
          element.parents('.form-group').append(label);
        } else {
          label.insertAfter(element);
        }
      },
      messages: {
        //
      },
      rules: {
        external_link: {
          required: true,
          url: true,
        },
      },
    });

    $sendDeviceForm.on('submit', function (e) {
      e.preventDefault();

      var $myForm = $(this);
      var target = $myForm.attr('action');
      // var formData = $myForm.serializeArray();
      var formData = new FormData(this);
      var $submitButton = $myForm.find('button[type=submit]');
      var submitButtonHtml = $submitButton.html();

      $myForm.find('.alert').fadeOut();

      if (!sendDeviceFormValidator.valid()) {
        // Check if form is valid
        return false;
      }

      $submitButton
        .attr('disabled', 'disabled')
        .html('<i class=\'fas fa-circle-notch fa-spin\'></i>');

      formData.append('action', 'ajaxsenddevice');

      grecaptcha
        .execute(recaptchaPublicKey, { action: 'contact' })
        .then(function (token) {
          formData.append('recaptchaToken', token);

          $.ajax({
            type: 'POST',
            data: formData,
            url: target,
            processData: false,
            contentType: false,
          })
            .always(function () {
              $submitButton.removeAttr('disabled').html(submitButtonHtml);
            })
            .done(function () {
              var $alert = $myForm.parent().find('.alert-success');
              $myForm.fadeOut(function () {
                $alert.fadeIn();
                $('html, body').animate({
                  scrollTop: $alert.offset().top - 30,
                });
              });
            })
            .fail(function (response) {
              var $alert = $myForm.find(
                '.alert.alert-danger[data-error-id=' +
                  response.responseJSON.data.error_id +
                  ']'
              );

              if ($alert.length <= 0) {
                $alert = $myForm.find(
                  '.alert.alert-danger[data-error-id=none]'
                );
              }

              if ($alert.length > 0) {
                $alert.fadeIn();
                $('html, body').animate({
                  scrollTop: $alert.offset().top - 30,
                });
              }
            });
        });
    });
  }
});

function checkAskDeviceForm($form) {
  var $destSuivi = $form.find('[name=dest_suivi]:checked');
  var $destSuiviOther = $form.find('.form-group.dest_suivi_other');

  if ($destSuivi.length > 0 && $destSuivi.attr('id') == 'dest_suivi_other') {
    $destSuiviOther.show();
  } else {
    $destSuiviOther.hide();
  }
}



// WEBPACK FOOTER //
// ./scripts/autoload/_device_forms.js